/**
 * Gift Box Sync Manager
 * Syncs removal of all gift box items when one is removed
 */
class GiftBoxSyncManager {
  constructor() {
    this.init();
  }

  init() {
    this.setupRemoveSync();
  }

  setupRemoveSync() {
    document.addEventListener("click", (e) => {
      const removeLink = e.target.closest('a[href*="/cart/change"]');
      if (!removeLink) return;

      const giftBoxGroup = removeLink.closest("[data-gift-box-group]");
      if (!giftBoxGroup) return;

      e.preventDefault();
      const giftBoxId = giftBoxGroup.dataset.giftBoxGroup;
      this.removeEntireGiftBox(giftBoxId, giftBoxGroup);
    });
  }

  async removeEntireGiftBox(giftBoxId, giftBoxGroup) {
    try {
      this.showLoadingState(giftBoxGroup);

      const removeLinks = giftBoxGroup.querySelectorAll(
        'a[href*="/cart/change"]'
      );

      const lineKeys = [
        ...new Set(
          Array.from(removeLinks)
            .map((link) => {
              const url = new URL(link.href);
              return url.searchParams.get("id");
            })
            .filter(Boolean)
        ),
      ];

      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      let finalCart = null;

      for (const lineKey of lineKeys) {
        const response = await fetch(
          `${window.Shopify.routes.root}cart/change.js`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: lineKey,
              quantity: 0,
              sections: sectionsToBundle,
            }),
          }
        );

        if (response.ok) {
          finalCart = await response.json();
        } else {
          console.error("Failed to remove item:", lineKey);
        }
      }

      if (finalCart) {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "gift-box:remove",
              cart: finalCart,
            },
          })
        );
      }
    } catch (error) {
      console.error("Error removing gift box:", error);
      this.showErrorState(giftBoxGroup);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }

  showLoadingState(giftBoxGroup) {
    const pillLoaders = giftBoxGroup.querySelectorAll("pill-loader");
    pillLoaders.forEach((loader) => {
      loader.setAttribute("aria-busy", "true");
    });
    giftBoxGroup.style.pointerEvents = "none";
  }

  showErrorState(giftBoxGroup) {
    const pillLoaders = giftBoxGroup.querySelectorAll("pill-loader");
    pillLoaders.forEach((loader) => {
      loader.removeAttribute("aria-busy");
    });
    giftBoxGroup.style.pointerEvents = "";
    console.error("Gift box removal failed - page will reload in 2 seconds");
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new GiftBoxSyncManager();
  });
} else {
  new GiftBoxSyncManager();
}
